import { createFileRoute, notFound } from '@tanstack/react-router'
import type { ComponentType } from 'react'
import {
  ApprovalsPage,
  CompanyPage,
  ContractsPage,
  OnboardingPage,
  ProposalContentPage,
  QuotesPage,
  TaxPage,
} from '@/components/settings/pages'
import { DictationSettingsPage } from '@/components/settings/dictation-settings'
import { EmailSettingsPage } from '@/components/settings/email-settings'
import { IntegrationsPage } from '@/components/settings/integrations'
import { PriceBookPage } from '@/components/settings/price-book'
import { SETTINGS_NAV } from '@/components/settings/sections'
import { UsersPage } from '@/components/settings/users'
import type { StaffUser } from '@/lib/session'
import { useTitle } from '@/lib/use-title'

const PAGES: Record<string, ComponentType<{ me: StaffUser }>> = {
  company: CompanyPage,
  tax: TaxPage,
  'price-book': PriceBookPage,
  quotes: QuotesPage,
  proposal: ProposalContentPage,
  approvals: ApprovalsPage,
  contracts: ContractsPage,
  onboarding: OnboardingPage,
  email: EmailSettingsPage,
  dictation: DictationSettingsPage,
  integrations: IntegrationsPage,
  users: UsersPage,
}

export const Route = createFileRoute('/_app/settings/$slug')({
  beforeLoad: ({ params }) => {
    if (!PAGES[params.slug]) throw notFound()
  },
  component: SettingsPage,
})

function SettingsPage() {
  const { slug } = Route.useParams()
  const { me } = Route.useRouteContext()
  const nav = SETTINGS_NAV.find((s) => s.slug === slug)!
  useTitle(nav.title)
  if (nav.visible && !nav.visible(me)) {
    return (
      <p className="rounded-lg border bg-muted p-4 text-[15px]">
        You do not have access to {nav.title.toLowerCase()}. Ask an owner or platform admin.
      </p>
    )
  }
  const Page = PAGES[slug]!
  return <Page me={me} />
}
